
export default () => {
  $('.buy-box--buy-trigger').on('click', function(e){
    e.preventDefault();
    $('form.cart').find('button').trigger('click');
  });
};
